import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 71.99560480000001,
			d: "m532.193 111.526 369.21 369.21a56.17 56.17 0 0 1 0 79.438L623.028 838.549a56.13 56.13 0 0 1-39.72 16.445 56.13 56.13 0 0 1-39.718-16.445l-369.21-369.21z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 68.92,
			d: "M1548.14 4346.38h589.93",
			transform: "matrix(.95234 0 0 1.12952 -1171.96 -4311.95)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 83.79,
			d: "M1548.14 4346.38h589.93",
			transform: "rotate(-45 -4829.05 2772.345)scale(.44842 1.12952)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 71.99560480000001,
			d: "M174.387 912.498c153.535 0 0-216.868 0-216.868s-153.536 216.868 0 216.868"
		})
	]
});
export default SvgIconFill;
